import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Cloud, CloudOff, RefreshCw } from "lucide-react";
import { api } from "../lib/api";
import { syncLabel } from "../lib/desktop";

export const CloudSyncBadge = () => {
  const [s, setS] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    const load = () => api.get("/desktop/sync").then(({ data }) => setS(data)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    const onSync = (e) => setS(e.detail);
    window.addEventListener("mufa-sync", onSync);
    return () => { clearInterval(t); window.removeEventListener("mufa-sync", onSync); };
  }, []);
  const ok = s?.linked && s.status === "ok";
  const Icon = s?.running ? RefreshCw : ok ? Cloud : CloudOff;
  return (
    <button onClick={() => nav("/pengaturan?tab=cloud")} title={s?.last_error || syncLabel(s)} data-testid="cloud-sync-badge"
      className={`flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-full border transition-colors ${ok ? "" : "border-warning/50 bg-warning/10"}`}>
      <Icon className={`h-3.5 w-3.5 ${ok ? "text-success" : "text-warning"} ${s?.running ? "animate-spin" : ""}`} />
      <span className="hidden sm:inline" data-testid="cloud-sync-label">{syncLabel(s)}</span>
    </button>
  );
};
